import React from 'react'
import html from '../../Assets/html5.svg'
import css from '../../Assets/css.svg'
import javascript from '../../Assets/javascript.svg'
import react from '../../Assets/react.svg'
import redux from '../../Assets/redux.svg'
import tailwind from '../../Assets/tailwind.svg'


export const Skills = () => {
  return (
    <div className='bg-blue-600 p-8 md:p-14  relative ' id="skills">
        <div className='left-1/2 -translate-x-1/2  px-4 inline-block absolute top-4 md:top-6 bg-blue-600'>
            <span className='text-white font-bold  text-2xl md:text-6xl'>My Skills</span>
        </div>
        <div className='flex gap-2 flex-wrap justify-evenly  items-center border-4 border-white rounded-md p-4 md:py-16 md:pt-16'>
            <div className='flex flex-col items-center group '>
                <img src={html} alt="" className='size-8 md:size-24 group-hover:scale-110 duration-200 ease-in-out ' />
                <span className='text-white  font-bold text-sm md:text-2xl group-hover:scale-110 duration-200 ease-in-out'>HTML5</span>
            </div>
            <div className='flex flex-col items-center group'>
                <img src={css} alt=""  className=' size-8 md:size-28 group-hover:scale-110 duration-200 ease-in-out '/>
                <span className='text-white  font-bold  text-sm md:text-2xl group-hover:scale-110 duration-200 ease-in-out'>CSS3</span>
            </div>
            <div className='flex flex-col items-center group'>
                <img src={javascript} alt="" className=' size-8 md:size-24 group-hover:scale-110 duration-200 ease-in-out'/>
                <span className='text-white  font-bold text-sm md:text-2xl group-hover:scale-110 duration-200 ease-in-out'>JavaScript</span>
            </div>
            <div className='flex flex-col items-center group'>
                <img src={react} alt="" className='size-8 md:size-24 group-hover:scale-110 duration-200 ease-in-out' />
                <span className='text-white  font-bold text-sm md:text-2xl group-hover:scale-110 duration-200 ease-in-out'>React JS</span>
            </div>
            <div className='flex flex-col items-center group'>
                <img src={redux} alt="" className='size-8 md:size-24 group-hover:scale-110 duration-200 ease-in-out'/>
                <span className='text-white  font-bold text-sm md:text-2xl group-hover:scale-110 duration-200 ease-in-out'>Redux</span>
            </div>
            <div className='flex flex-col items-center group'>
                <img src={tailwind} alt="" className='size-8 md:size-24 group-hover:scale-110 duration-200 ease-in-out' />
                <span className='text-white  font-bold text-sm md:text-2xl group-hover:scale-110 duration-200 ease-in-out '>Tailwind CSS</span>
            </div>
        </div>
    </div>
  )
}
